import { Button, IconButton, Label } from '@localina/core';
import { CloseIcon } from '@localina/icons';
import { Dialog as MuiDialog } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

/** what to do with the fee when a reservation with a chargeable guarantee is saved as no-show */
export type TNoShowChoice = 'charge' | 'waive' | 'later';

interface IProps {
    open: boolean;
    amount: string;
    guestName: string;
    onChoose: (choice: TNoShowChoice) => void;
    /** closed without a choice: nothing is saved */
    onClose: () => void;
}

/**
 * No-Show Protection (PO, 3.11.): saving "No-show" asks right away what happens with the fee, so staff don't have to
 * find the no-show again to charge it. Three choices don't fit the confirm dialog, so this is the same card with a
 * button per choice.
 */
export const NoShowChargeDialog: React.FC<IProps> = (props) => {
    const { t } = useTranslation();
    return (
        <MuiDialog className="localina-dialog no-show-charge-dialog" open={props.open} onClose={props.onClose}>
            <IconButton
                className="localina-dialog__close"
                icon={<CloseIcon />}
                ariaLabel={t('common.buttons.close')}
                onClick={props.onClose}
            />
            <Label
                type="text"
                value={t('reservations.guarantee.noShowDialog.title')}
                extraClassName="localina-dialog__title"
            />
            <Label
                type="text"
                value={t('reservations.guarantee.noShowDialog.message', {
                    amount: props.amount,
                    name: props.guestName,
                })}
                extraClassName="localina-dialog__message"
            />
            <div className="localina-dialog__actions no-show-charge-dialog__actions">
                <Button
                    label={t('reservations.guarantee.noShowDialog.charge', { amount: props.amount })}
                    onClick={() => props.onChoose('charge')}
                />
                <Button
                    secondary
                    label={t('reservations.guarantee.noShowDialog.waive')}
                    onClick={() => props.onChoose('waive')}
                />
                <Button
                    secondary
                    label={t('reservations.guarantee.noShowDialog.later')}
                    onClick={() => props.onChoose('later')}
                />
            </div>
        </MuiDialog>
    );
};
